import { Expose } from "class-transformer";

export class CreateTimeOffHasFileDto {
  @Expose()
  timeOffId: string;

  @Expose()
  fileId: string;
}
